import script from "./TargetNumbers.vue?vue&type=script&setup=true&lang=ts"
export * from "./TargetNumbers.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__